import setFilters from 'store/reducer-utils/setFilters'
import {
  CLIENTS_FILTERS_APPLY,
  CLIENTS_RESET_DATA,
  CLIENTS_SET_DATA,
  CLIENTS_SET_FILTERS,
  CLIENTS_UPDATE_DATA,
} from 'modules/Referral/ReferralClients/types'

const initialState = {
  data: null,
  pagination: {
    limit: 20,
    offset: 0,
  },
  filters: null,
}

const setReferralClientsFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(
    {
      ...state,
      data: null,
      pagination: { ...initialState.pagination },
    },
    { ...action, payload: filteredPayload },
  )
}

const applyReferralClientsFilters = (state, { payload }) => ({
  ...state,
  filters: payload,
})

const setReferralClientsData = (state, { payload: { data, pagination } }) => ({
  ...state,
  data: [...(state?.data ?? []), ...data],
  pagination: { ...state.pagination, ...pagination },
})

const resetReferralClientsData = (state, { payload = {} }) => ({
  ...initialState,
  ...payload,
})

const updateReferralClientsData = (state, { payload: { id, ...rest } }) => ({
  ...state,
  data:
    state?.data.map((client) =>
      client.id === id ? { ...client, ...rest } : client,
    ) ?? [],
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENTS_RESET_DATA:
      return resetReferralClientsData(state, action)
    case CLIENTS_SET_FILTERS:
      return setReferralClientsFilters(state, action)
    case CLIENTS_FILTERS_APPLY:
      return applyReferralClientsFilters(state, action)
    case CLIENTS_SET_DATA:
      return setReferralClientsData(state, action)
    case CLIENTS_UPDATE_DATA:
      return updateReferralClientsData(state, action)
    default:
      return state
  }
}

export default reducer
